import { AddInData, Geotab } from "@fairfleet/geotab";
import { LicenseCheckDisplayData } from "../models/LicenseCheckDisplayData";
import AddInIds from "@/constants/AddInIds";

export default async function updateNextCheckDate(
  geotabClient: Geotab,
  data: LicenseCheckDisplayData[] | undefined,
   
  updatedRow: any,
) {
  const currentData = data?.find(d => d.userId === updatedRow.userId);
  if (!currentData) {
    throw new Error("Something went wrong, please try again.");
  }
  const method = currentData.nextCheckEntityId === "" ? "Add" : "Set";
  const newAddin: AddInData = {
    addInId: AddInIds.nextLicenseCheckDate,

     
    // @ts-ignore
    details: {
      userid: currentData.userId,
      nextCheckDate: updatedRow.nextCheckDate,
    },
  };
  if (method === "Set") {
    newAddin.id = currentData.nextCheckEntityId;
  }
  await geotabClient.call(method, { typeName: "AddInData", entity: newAddin });
}
